import { createFileRoute, redirect } from '@tanstack/react-router';
import { requireAuthenticated } from '@/lib/auth/authSnapshot';
import { signedInDestination } from '@/lib/auth/signedInDestination';

export const Route = createFileRoute('/')({
  beforeLoad: () => {
    const { tenantType, slug } = requireAuthenticated();

    // Ask the shared placement policy rather than re-deriving it: branching on
    // `slug` alone would send a partner (who has one, but no customer app) into
    // `/$slug`, leaving correctness to that route's own guard running first.
    const destination = signedInDestination({ tenantType, tenant: { slug } });

    // Session without a workspace slug yet — stay put rather than navigate to
    // an empty `/$slug`.
    if (destination.to === '/$slug' && !slug) return;

    throw redirect(destination);
  }
});
